// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type AlertConfigRuleFragment = {
  __typename?: "AlertRule";
  id: string;
  name: string;
};

export type AlertConfigDetailsQueryVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
  serverId?: Types.InputMaybe<Types.Scalars["ID"]["input"]>;
}>;

export type AlertConfigDetailsQuery = {
  __typename?: "GraphqlQuery";
  getAlertCheckConfigs: Array<{
    __typename?: "CheckAlertConfig";
    checkKind: string;
    rules: Array<{ __typename?: "AlertRule"; id: string; name: string }>;
    inheritedRules: Array<{
      __typename?: "AlertRule";
      id: string;
      name: string;
    }>;
  }>;
};

export const AlertConfigRuleFragmentDoc = gql`
  fragment AlertConfigRule on AlertRule {
    id
    name
  }
`;
export const AlertConfigDetailsDocument = gql`
  query AlertConfigDetails($organizationSlug: ID!, $serverId: ID) {
    getAlertCheckConfigs(
      organizationSlug: $organizationSlug
      serverId: $serverId
    ) {
      checkKind
      rules {
        ...AlertConfigRule
      }
      inheritedRules {
        ...AlertConfigRule
      }
    }
  }
  ${AlertConfigRuleFragmentDoc}
`;

/**
 * __useAlertConfigDetailsQuery__
 *
 * To run a query within a React component, call `useAlertConfigDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertConfigDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertConfigDetailsQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *      serverId: // value for 'serverId'
 *   },
 * });
 */
export function useAlertConfigDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AlertConfigDetailsQuery,
    AlertConfigDetailsQueryVariables
  > &
    (
      | { variables: AlertConfigDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AlertConfigDetailsQuery,
    AlertConfigDetailsQueryVariables
  >(AlertConfigDetailsDocument, options);
}
export function useAlertConfigDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AlertConfigDetailsQuery,
    AlertConfigDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AlertConfigDetailsQuery,
    AlertConfigDetailsQueryVariables
  >(AlertConfigDetailsDocument, options);
}
// @ts-ignore
export function useAlertConfigDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AlertConfigDetailsQuery,
    AlertConfigDetailsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AlertConfigDetailsQuery,
  AlertConfigDetailsQueryVariables
>;
export function useAlertConfigDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AlertConfigDetailsQuery,
        AlertConfigDetailsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AlertConfigDetailsQuery | undefined,
  AlertConfigDetailsQueryVariables
>;
export function useAlertConfigDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AlertConfigDetailsQuery,
        AlertConfigDetailsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AlertConfigDetailsQuery,
    AlertConfigDetailsQueryVariables
  >(AlertConfigDetailsDocument, options);
}
export type AlertConfigDetailsQueryHookResult = ReturnType<
  typeof useAlertConfigDetailsQuery
>;
export type AlertConfigDetailsLazyQueryHookResult = ReturnType<
  typeof useAlertConfigDetailsLazyQuery
>;
export type AlertConfigDetailsSuspenseQueryHookResult = ReturnType<
  typeof useAlertConfigDetailsSuspenseQuery
>;
export type AlertConfigDetailsQueryResult = Apollo.QueryResult<
  AlertConfigDetailsQuery,
  AlertConfigDetailsQueryVariables
>;
